module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchStep($event)
      },
      "input": function($event) {
        return _vm.productAcivateUpdateFlag('details')
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-4 px-4"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('add-image', {
    attrs: {
      "currentImage": (this.form.imageLogo) ? this.form.imageLogo : this.form.imageLogoBase64
    },
    on: {
      "imageChanged": _vm.imageChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel mt-0 shaded radius-top-left-none radius-top-right-none"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-8",
    class: {
      error: _vm.$v.form.name.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                Product name\n                                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                                    *\n                                                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }, _vm.$v.form.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                Code\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.getCategories) ? _c('div', [_vm._m(0), _vm._v(" "), _c('multiselect', {
    attrs: {
      "searchable": false,
      "options": _vm.categories,
      "multiple": true,
      "taggable": true,
      "track-by": "id",
      "label": "name",
      "selectLabel": "",
      "deselectLabel": ""
    },
    on: {
      "input": _vm.categoriesChanged
    },
    model: {
      value: (_vm.form.categoryList),
      callback: function($$v) {
        _vm.$set(_vm.form, "categoryList", $$v)
      },
      expression: "form.categoryList"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.getEventColors) ? _c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                Color\n                                            ")]), _vm._v(" "), _c('color-picker', {
    attrs: {
      "selectedId": _vm.form.color,
      "colors": _vm.getEventColors
    },
    on: {
      "colorChanged": _vm.updateColor
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row my-4"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('checkbox', {
    on: {
      "input": _vm.changePrivateStatus
    },
    model: {
      value: (_vm.form.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.form, "isPrivate", $$v)
      },
      expression: "form.isPrivate"
    }
  }, [_vm._v("\n                                                Private tour / Charter.\n                                                "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("\n                                                    Only one booking per tour is allowed.\n                                                ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                Brief description\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.descriptionBrief),
      expression: "form.descriptionBrief"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.descriptionBrief)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "descriptionBrief", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                Product description\n                                            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                                Ticket information (Terms and conditions, Checkin information, Others)\n                                            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.descriptionMore),
      expression: "form.descriptionMore"
    }],
    attrs: {
      "rows": "30",
      "placeholder": "e.g. Cancellations and changes accepted up to 48 hours before the event"
    },
    domProps: {
      "value": (_vm.form.descriptionMore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "descriptionMore", $event.target.value)
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "panel shaded mt-0",
    class: {
      error: _vm.$v.form.location.$error
    }
  }, [_vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g. Albufeira, Marina de Albufeira"
    },
    domProps: {
      "value": (_vm.form.location)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "location", $event.target.value)
      }, _vm.$v.form.location.$touch]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller normal mt-2"
  }, [_vm._v("Insert a location or starting point for this product.")])]), _vm._v(" "), (_vm.$v.form.location.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.location.required) ? _c('span', [_vm._v("Location is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark mt-2 mb-3"
  }, [_vm._v("\n                                        This information will be displayed on the calendar and on new reservations page.\n                                    ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.internalNote),
      expression: "form.internalNote"
    }],
    domProps: {
      "value": (_vm.form.internalNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "internalNote", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Booking question")]), _vm._v(" "), _c('label', {
    staticClass: "full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bookingQuestion),
      expression: "form.bookingQuestion"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g. Do you have the required fishing license?"
    },
    domProps: {
      "value": (_vm.form.bookingQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bookingQuestion", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller normal mt-2"
  }, [_vm._v("Use this if you want to add a question to the booking process.")])]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.form.bookingQuestionIsActive),
      callback: function($$v) {
        _vm.$set(_vm.form, "bookingQuestionIsActive", $$v)
      },
      expression: "form.bookingQuestionIsActive"
    }
  }, [_vm._v("\n                                        Is question active.\n                                    ")]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.form.bookingQuestionIsMandatory),
      callback: function($$v) {
        _vm.$set(_vm.form, "bookingQuestionIsMandatory", $$v)
      },
      expression: "form.bookingQuestionIsMandatory"
    }
  }, [_vm._v("\n                                        Is question mandatory.\n                                    ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-4 px-4"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("Product categories"), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Location "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-45bb33fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45bb33fa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductEdit.vue
// module id = 1014
// module chunks = 0